// extracted by mini-css-extract-plugin
export default {"styleChooserSection":"c3-z","dimensionLabel":"d3-z","styleChooserControlWrapper":"e3-z","styleChooserControl":"f3-z","disabled":"g3-z","giftCard":"h3-z","styleChooserText":"i3-z"};